import { Image } from '@bw/elements';
import { Block } from '../../factories/types';
import { annotate } from '../../utils/annotate';
import { RichText } from '../../utils/rich-text/RichText';
import styles from './GridItem.module.scss';

export const GridItem: Block<'item'> = ({ data }) => {
	const {
		fields: { title, text, image },
	} = data;

	return (
		<div className={styles.gridItem}>
			{image?.fields.file?.url ? (
				<div className={styles.imageWrapper}>
					<Image src={image.fields.file.url} alt="" width={32} height={32} />
				</div>
			) : null}

			{title && (
				<div className={styles.title} {...annotate(data, 'title')}>
					<RichText document={title} />
				</div>
			)}

			{text && (
				<div className={styles.text} {...annotate(data, 'text')}>
					<RichText document={text} />
				</div>
			)}
		</div>
	);
};
